import { Query } from "@datorama/akita";
import { injectable } from "tsyringe";

import LeaveReviewEarningRuleStore, {
    LeaveReviewEarningRuleState,
} from "../stores/LeaveReviewEarningRuleStore";

@injectable()
class LeaveReviewEarningRuleQuery extends Query<LeaveReviewEarningRuleState> {
    constructor(protected store: LeaveReviewEarningRuleStore) {
        super(store);
    }

    leaveReviewEarningRule$ = this.select(
        (state) => state.leaveReviewEarningRule
    );
    loading$ = this.selectLoading();
}

export default LeaveReviewEarningRuleQuery;
